import React, {createContext, useState, useContext, useEffect, ReactNode} from 'react'

interface SubmenuContextType {
    submenuType: string
    setSubmenuType: (type: string) => void
}

const SubmenuContext = createContext<SubmenuContextType>({
    submenuType: 'core',
    setSubmenuType: () => {},
})

export const useSubmenu = () => {
    const context = useContext(SubmenuContext)

    if (context === undefined) {
        throw new Error('useSubmenu deve ser usado dentro de um SubmenuProvider')
    }
    return context
}

interface SubmenuProviderProps {
    children: ReactNode
}

export const SubmenuProvider = ({children}: SubmenuProviderProps) => {
    const [submenuType, setSubmenuType] = useState<string>(() => {
        const savedType = localStorage.getItem('submenuType')
        return savedType || 'core'
    })

    useEffect(() => {
        localStorage.setItem('submenuType', submenuType)
    }, [submenuType])

    const value: SubmenuContextType = {submenuType, setSubmenuType}
    return <SubmenuContext.Provider value={value}>{children}</SubmenuContext.Provider>
}
